import { useMemo } from 'react';
import { Alert, Box, List, Text } from '@nimbus-ds/components';
import { combineStatus } from 'commons/utils/combineStatus';
import {
  useGetRecurrentPaymentConcepts,
  usePayorderToPay,
} from 'domains/Billing/Checkout/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

export default function RecurrentPaymentAlert() {
  const t = useTranslationBilling('checkout.recurrentPaymentActiveAlert');

  const { payorderToPay, status: payorderStatus } = usePayorderToPay();
  const { recurrentPaymentForConcept, status: recurrentPaymentStatus } =
    useGetRecurrentPaymentConcepts();
  const { isSuccess } = combineStatus(payorderStatus, recurrentPaymentStatus);

  const hasConceptsWithRpActive = useMemo(
    () =>
      payorderToPay?.charges.some(({ conceptCode, metadata }) =>
        recurrentPaymentForConcept(conceptCode, metadata?.appId),
      ),
    [payorderToPay, recurrentPaymentForConcept],
  );

  if (!isSuccess || !hasConceptsWithRpActive) return null;

  return (
    <Alert appearance="warning" title={t('title')}>
      <Box display="flex" flexDirection="column" gap="1">
        <List as="ul">
          <List.Item>
            <Text>{t('message1')}</Text>
          </List.Item>
          <List.Item>
            <Text>{t('message2')}</Text>
          </List.Item>
        </List>
      </Box>
    </Alert>
  );
}
